import React from 'react';
import Type from 'components/Type';
import SectionHeadline from 'components/SubLandingPage/SectionHeadline';
import StepList from 'components/SubLandingPage/StepList';
import StepListItem from 'components/SubLandingPage/StepListItem';
import SectionWrapper from 'components/SubLandingPage/Duo/SectionWrapper';
import { useTranslation } from 'data/translation/useTranslation';
import * as tokens from 'styles';

const StepsDisplay = () => {
  const { t } = useTranslation();
  return (
    <SectionWrapper style={{ background: tokens.white }}>
      <SectionHeadline paddingBottom={tokens.spacer24}>
        {t('sub_landing_page.its_easy')}
      </SectionHeadline>
      <StepList>
        <StepListItem>
          {t('sub_landing_page.topics.tap_accept_invite')}
        </StepListItem>
        <StepListItem>{t('sub_landing_page.topics.sign_up')}</StepListItem>
        <StepListItem>
          {t('sub_landing_page.topics.confirm_address')}
        </StepListItem>
      </StepList>
      <Type.P>{t('sub_landing_page.ps.same_home')}</Type.P>
    </SectionWrapper>
  );
};

export default StepsDisplay;
